import home from '../home/home.vue';
import { AUTH_LOGOUT, AUTH_EXACHANGEUSER } from '../../store/actions/authactions';
import { mapActions, mapGetters } from 'vuex';
import activity from './components/activity.vue';
import activitychecks from './components/activitychecks.vue';
import {
    
    DASHBOARDLIST_DATE,

} from '../../store/actions/dashboardactions';
export default {
    components: {
        home
    },
    name: 'App',
    data() {
        return {
            // Custom name of your choice
            myEventSignal: {
                isMonthView: false
            }
        };
    },
    provide() {
        return {
            // Must match the key used in inject
            myEventSignal: this.myEventSignal
        };
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'user', 'testenvironment', 'useradmin', 'isClientReadOnly', 'twofactorwarning']),
        ...mapGetters('dashboardlist', [          
            'date',
        ]),
    },
    methods: {
        logout: function () {
            this.doLogout()
                .then(() => {
                    this.$router.push({ name: 'login' });
                });
        },
        adminlogin: function () {
            let self = this;
            let userdata = { username: this.user.username };
            this.exchangeuser(userdata)
                .then(() => {
                    if (self.user.role == 'Administrator')
                        this.$router.push({ name: 'schedule', query: { p: 1 } });
                    else
                        this.$router.push({ name: 'schedule' });

                });
        },
        //setTwoFactor() {
        //    this.$vuedals.open({
        //        title: this.$t('title.twofactorauthentication'),
        //        props: {
        //            id: 0,

        //        },
        //        component: twofactor,
        //        size: 'lg',
        //        escapable: true,
        //    });
        //},
        ...mapActions('auth', {
            doLogout: AUTH_LOGOUT,
            exchangeuser: AUTH_EXACHANGEUSER
        }),
        openactivity() {
            console.log(this.$t('title.newactivity'))
            this.$vuedals.open({
                title: this.$t('title.newactivity'),
                props: {
                    id: 0,

                },
                component: activity,
                size: 'lg',
                escapable: true
            });
        },
        opencheck() {
            console.log(this.$t('title.newactivity'))
            this.$vuedals.open({
                title: this.$t('title.controls'),
                props: {
                    month: 0,
                    year: 0,
                    date: this.date
                },
                component: activitychecks,
                size: 'lg',
                escapable: true,
            });
        },
        setMonthView(val) {
            this.myEventSignal.isMonthView = val;
        }
    }
};